import { routes as billPaymentRoutes } from "./bill-payments/routes";
import { routes as coaRoutes } from "./coas/routes";
import { routes as assetRoutes } from "./Assets/routes";
import { routes as expensesRoutes } from "./Expenses/routes";
import { routes as bankingRoutes } from "./banking/routes";
import { routes as cashsalesRoutes } from "./Cash-sales/routes";

export const routes = (prefix = `finance-dashboard`) => [
    {
        path: `/finance-dashboard`,
        name: `finance-dashboard.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `finance-dashboard.index`,
                PageDescription: "Finance Dashboard",
            },
        },
    },
    ...billPaymentRoutes(prefix),
    ...coaRoutes(prefix),
    ...assetRoutes(prefix),
    ...bankingRoutes(prefix),
    ...cashsalesRoutes(prefix),
    ...expensesRoutes(prefix),
];
